import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { Layout } from 'wanderu-components';
import SearchWidget from 'wanderu-widget';

import styles from './Search.scss';

const Search = (props) => {
    const [disableSearchButton, setDisableSearchButton] = useState(true);
    const {
        departDate,
        destinationPlaceId = '',
        destinationText = '',
        location,
        onDestinationChange,
        onDestinationInputChange = () => undefined,
        onOriginChange,
        onOriginInputChange = () => undefined,
        originPlaceId = '',
        originText = '',
        returnDate = '',
    } = props;

    return (
        <div className={styles.search}>
            <Layout>
                <SearchWidget
                    departDate={departDate}
                    destinationInput={destinationText}
                    destinationPlaceId={destinationPlaceId}
                    disableButton={disableSearchButton}
                    location={location}
                    onDestinationChange={onDestinationChange}
                    onDestinationInputChange={onDestinationInputChange}
                    onOriginChange={onOriginChange}
                    onOriginInputChange={onOriginInputChange}
                    onUserInputChange={() => setDisableSearchButton(false)}
                    onUserSearch={() => setDisableSearchButton(true)}
                    originInput={originText}
                    originPlaceId={originPlaceId}
                    readFromLocalStorage={false}
                    returnDate={returnDate}
                    searchPage
                    useLocalStorage
                />
            </Layout>
        </div>
    );
};

Search.propTypes = {
    departDate: PropTypes.string.isRequired,
    destinationPlaceId: PropTypes.string,
    destinationText: PropTypes.string,
    location: PropTypes.object,
    onDestinationChange: PropTypes.func,
    onDestinationInputChange: PropTypes.func,
    onOriginChange: PropTypes.func,
    onOriginInputChange: PropTypes.func,
    originPlaceId: PropTypes.string,
    originText: PropTypes.string,
    returnDate: PropTypes.string,
};

export default Search;
